import React from "react";
import PropTypes from "prop-types";

import { TextValue } from "scenes/Hubly/components/Workspace/components/FormFieldList/components";

export function ThisWorkflowText({ value, datePart }) {
  if (!value) {
    return null;
  }

  return (
    <div data-test="this-workflow-text">
      <TextValue
        style={{ padding: "0.3em 0.4em", margin: "0 0.5em 0.2em 0" }}
        type={
          datePart === "Date" ? { id: "DATE" } : { id: "MULTISELECT_DROPDOWN" }
        }
        value={value}
        prefix=""
      />
    </div>
  );
}

ThisWorkflowText.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  datePart: PropTypes.string,
};

ThisWorkflowText.defaultProps = {
  value: null,
  datePart: null,
};

export default ThisWorkflowText;
